import { AuthService } from './../services/auth/auth.service';
import { AlertService } from './../services/alert.service';
import { CustomHttpUrlEncodingCodec } from './../../../gen/swagger-api/encoder';
import { EndpointType } from './../model/endpoint-type';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { HttpResponse } from 'aws-sdk/global';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private endpointType: EndpointType;


  constructor(private readonly alertService: AlertService, private readonly authService: AuthService ) {
    this.endpointType = sessionStorage.getItem('endpointType') ===
      EndpointType.ENTERPRISE.toString() ? EndpointType.ENTERPRISE : EndpointType.SERVICEPROVIDER;
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url;
    let authMethod;
    if (this.endpointType === EndpointType.SERVICEPROVIDER) {
      url = environment.serviceProviderAccountEndpoint;
      authMethod = environment.serviceProviderEndpointAuthMethod;
    } else {
      url = environment.enterpriseAccountEndpoint;
      authMethod = environment.enterpriseAccountEndpointAuthMethod;
    }
    const authType = authMethod === 'jwt' ? 'Bearer' : 'Basic';

    const authRequest = request.clone({
      setHeaders: {
        Authorization: authType + ` ${sessionStorage.getItem('token')}`,
      },
      url: request.url.replace('[PLACEHOLDER]', url)
    });

    return next.handle(authRequest)
      .do(event => {
        if (event instanceof HttpResponse) {
          /* Make your code here */
        }
      })
      .catch((err) => {
        if (err.status === 500) {
          this.alertService.error(err.statusText);
        }
        if (err.status === 400) {
          this.alertService.errorModal(err.statusText + ': ' + err.headers.get('X-Status'), '');
        }
        // if (err.status === 403) {
        //   this.alertService.error('You are not authorized to perform this operation. Please contact administrator.');
        // }
        if (err.status === 401) {
          if (!this.authService.isAuthenticated()) {
            this.authService.logout();
          }
        }
        return Observable.throw(err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/auth.interceptor.ts